<script setup lang="ts">
  import { useFieldValidation } from '@/composables/useQuestionnaire'
  import { useTranslation } from '@/composables/useTranslation'
  import TextAreaField from '@/components/admin/form/TextAreaField.vue'
  import { onMounted } from 'vue'

  const props = defineProps({
    field: {
      type: Object,
      default: null
    },
    modelValue: {
      type: String,
      default: ''
    },
    descriptionId: {
      type: String,
      required: false
    }
  })

  const emit = defineEmits(['update:modelValue', 'validation-error'])

  const { t } = useTranslation({
    en: {
      enterAnswerHere: 'Enter your answer here...'
    },
    de: {
      enterAnswerHere: 'Geben Sie hier Ihre Antwort ein...'
    }
  })

  const { validationError, handleInputChange, validate } = useFieldValidation(props, emit)

  onMounted(() => {
    const textareaElement = document.querySelector(
      `textarea[name="${props.field.uuid}"]`
    ) as HTMLTextAreaElement
    if (textareaElement) {
      textareaElement.focus()
    }
  })

  function validateCurrentValue() {
    const result = validate(props.modelValue)
    validationError.value = result.errors[0] || ''
    emit('validation-error', !result.valid)
  }
</script>

<template>
  <div class="w-full">
    <TextAreaField
      :id="field.uuid"
      ref="textareaFieldRef"
      :name="field.uuid"
      :model-value="modelValue"
      :placeholder="t('enterAnswerHere')"
      :rows="'8'"
      :error="validationError"
      :description-id="descriptionId"
      class="w-full"
      :data-cy="`TextAreaV3Textarea-${field.uuid}`"
      @update:model-value="handleInputChange"
      @blur="validateCurrentValue"
    />
  </div>
</template>
